module.exports = __webpack_public_path__ + "img/product2x.png?0905d5d266188c2959b98208998ec237";